// import 'whatwg-fetch';
import '../@types';
import {getCurrentUrl, getPandoraData, isFacebook, isInstagram, isQQ, isWeChat} from './libs/tools';
import './libs/reporter';
import {DeepLinkType, getActivityConfig, gotoGame, registerDeeplinkButton} from './libs/utils';
import {getCurrentLanguage} from "./libs/i18n";

// @ts-ignore
import ClipboardJS from 'clipboard';
// import {Debug, enableDebug} from "./libs/debug";
// import {getCurrentUrl} from "@intlsdk/account-api/dist/src/model/util";

// enableDebug(Debug.TRUE)

const CONST_DATA = {
    PANDORA_SHARE_KEY: 'inviteInfo',// 潘多拉分享数据的参数
};

const pandoraData = getPandoraData(CONST_DATA.PANDORA_SHARE_KEY,{
    module: 'PullPeople',
    appId: '2441',
    userName: '',
    code: '',
});

console.log('pandoraData==>',pandoraData)

function onError(err: ErrorEvent) {
    console.error('Uncaught error:', err.error || err.message || err, err);
}

// 全局未捕获错误处理
window.addEventListener('error', onError);
let jumpPandoraData: pandoraDataType;

function autoLunchGame(pandoraData:pandoraDataType){
    if(!isFacebook() && !isInstagram()){
        gotoGame(DeepLinkType.GOTO_PANDORA, pandoraData,()=>{
            console.log('默认拉起游戏成功~')
        },()=>{
            console.log('默认拉起游戏失败~')
            return false;
        })
    }
}


function initPage(){
    $(".over").hide();
}


function updatePageEnd(){
    // app.is_act_end = true;
    $(".main").removeClass('on');
    $(".over").show();
}

(async function(){
    let lang = getCurrentLanguage(language_data,'lang') as string;
    app.switchLanguage(lang)
    
    // app.invite_code = pandoraData.code;
    app.str_split(pandoraData.code); // 处理邀请码
    app.userName = pandoraData.userName
    jumpPandoraData = {...pandoraData};
    jumpPandoraData.userName = encodeURIComponent(jumpPandoraData.userName);
    
    // DeepLink 按钮
    registerDeeplinkButton('[data-deeplink]', jumpPandoraData,()=>{
        console.log('success')
    },()=>{
        console.log('失败跳转~');
        // if ((isIOS() && (isFacebook() || isInstagram())) || isWeChat() || isQQ()) {
        if(isWeChat() || isQQ() || isFacebook() || isInstagram()){
            let tip_browser = "top-right"
            if(lang === 'ar'){
                tip_browser = 'top-left'
            }
            app.showTipBrowser(tip_browser);
            return false;
        }
    });
    
    // 复制链接
    new ClipboardJS('.copyBtn', {
        text() {
            const content = getCurrentUrl();
            console.log('[Act] 触发复制事件~');
            return content || '';
        },
    });
    
    await getActivityConfig('a20240924hokpdd', {
        instanceid: 3000644,
    }, (data) => {
        console.log('拉取配置成功~==>', data);
        const {now, iActivityEndTime} = data;
        if (now >= iActivityEndTime) {
            // 活动结束
            updatePageEnd();
        } else {
            initPage();
        }
    }, (error) => {
        console.error('拉取配置失败~', error);
        initPage();
    });
    
    // autoLunchGame(jumpPandoraData);
})();